module.exports = {
    licenseCegString: process.env.LICENSE_CEG_STRING || '',
};